module.exports = __webpack_public_path__ + "img/shiLin6.528dc07d.png";